<template>
    <!-- 
        General selector component

        required input: 
            options         : array of objects  - { 
                                                    "Option"      : "001",                       // Code op option.
                                                    "Description" : "Visible display value",     // Display value for option.
                                                    "isSelected"  : true                         // Initial select status of option.
                                                  } for dropdown
            option_field    : string            - Name of "field" for "update" callback

        optional input: 
            label           : String            - Label for dropdown, defaults to "Status" 
            isClearable     : Boolean           - Show X to clear value, defaults to false
            isDense         : Boolean           - Show "dense" component, default to false
            isMultiple      : Boolean           - Allow multiple selects, defaults to true
            visibleChips    : Number            - Mumber of chips to show on display, defaults to 5
    -->
    <v-select 
       v-model="selected_codes"
       :value="codes"      
       :items="codes"
       item-value="Option" 
       item-text="Description" 
       :label="label"
       :dense="isDense"
       :clearable="isClearable"
       :multiple="isMultiple"
       return-object
       @blur="updateData()"
       v-on:click:clear="callClear()">
       <template v-slot:prepend-item>
            <v-list-item ripple @mousedown.prevent @click="toggle">
                <v-list-item-action>
                    <v-icon :color="selected_codes.length > 0 ? 'indigo darken-4' : ''"> {{ getIcon() }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>       
        <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index >= 0 && index < visibleChips">
                <span>{{ item.Description }}</span>
            </v-chip>
            <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ selected_codes.length - visibleChips }})</span>
        </template>
    </v-select>
</template>

<script>
    export default {
        props: {
            options: {
                type: Array,
                required: true,
            },
            option_field: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: false,
                default: "Status",
            },   
            isClearable:{
                type: Boolean,
                default: false
            },
            isDense: {
                type: Boolean,
                init: false
            },
            isMultiple:{
                type: Boolean,
                default: true
            },  
            visibleChips:{
                type: Number,
                default: 5
            },
        },    
        data() {
            return {
                codes: [],
                selected_codes: [],
            }
        },
        mounted() {
            this.codes = this.options;
            this.updateSelector(this.codes);
        },
        methods: {
            getIcon: function () {
                if (this.isAllSelected()) return 'mdi-close-box'
                if (this.isSomeSelected()) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },    
            isAllSelected: function () {
                return this.selected_codes.length === this.codes.length; 
            },
            isSomeSelected: function () {
                return this.selected_codes.length > 0 && this.selected_codes.length !== this.codes.length;
            },   
            toggle() {
                this.$nextTick(() => {
                    if (this.isAllSelected()) {
                        this.selected_codes = [];
                    } else {
                        this.selectAll();
                    }
                    this.updateData();
                });
            },
            callClear() {
                this.selected_codes = [];
            },
            selectAll() {
                this.selected_codes = [];
                this.codes.forEach(x => {
                    this.selected_codes.push(x);
                });
            }, 
            updateSelector(newOptions) {
                this.codes = newOptions;
                this.selected_codes = [];
                this.codes.forEach(x => {
                    if (x.isSelected) {
                        this.selected_codes.push(x);
                    }
                });
            },
            updateData() {  
                // console.log(this.selected_codes);
                this.$emit('updateData', { "field": this.option_field, "value": this.selected_codes })
            },
        }
    }
</script>

<style scoped>

</style>